import { useMemo } from 'react';
import { useAssistantState } from '@assistant-ui/react';

export const useIsAssistantMessageLoading = (): boolean => {
  const isRunning = useAssistantState(state => state.thread.isRunning);
  const isLast = useAssistantState(state => state.message.isLast);

  return useMemo<boolean>(() => {
    if (!isLast) {
      return false;
    }

    return isRunning;
  }, [isLast, isRunning]);
};
